import { Component, HostListener, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NavigationService } from 'src/app/service/navigation.service';

@Component({
	selector: 'app-portal-header',
	templateUrl: './portal-header.component.html',
	styleUrls: ['./portal-header.component.css']
})
export class PortalHeaderComponent implements OnInit {

	isSticky: boolean = false;

	constructor(
		private router: Router,
		private navigate: NavigationService
	) {
	}

	@HostListener('document:scroll', [])
		onWindowScroll() {
			const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		
			if (offset > 200) {
			  this.isSticky = true;
			} else {
			  this.isSticky = false;
			}
	}

	ngOnInit() {
	}

	goHome() {
		this.navigate.navigateToHome()
	}

	goAboutUs() {
		this.navigate.navigateToAbout()
	}

	goBlog() {
		this.navigate.navigateToBlog()
	}

	goQuote() {
		this.navigate.navigateToQuote()
	}

	goBenefits() {
		this.navigate.navigateToBenefits()
	}

	goInsured() {
		this.navigate.navigateToInsured()
	}


}
